import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import React, { FunctionComponent, useRef, useState } from 'react';
import { ScaleLoader } from 'react-spinners';
import { useTheme } from 'styled-components';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Container, SearchInputContainer, SearchInput, Icon, Input, LoadingBox } from './FaqSearch.style';

interface FaqSearchProps {
  searchText: string;
  setSearchText: (v: string) => void;
}

const FaqSearch: FunctionComponent<FaqSearchProps> = ({ searchText, setSearchText }) => {
  const [isLoading, _setIsLoading] = useState<boolean>();

  const inputRef = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const theme = useTheme();

  return (
    <Container>
      <SearchInputContainer>
        <SearchInput ref={containerRef}>
          <Icon
            aria-label="Focus faq search input"
            onClick={() => inputRef?.current?.focus()}
            data-testid="faqSearchInputIcon"
            type="button"
            tabIndex={-1}
          >
            <FontAwesomeIcon icon={faSearch} color={theme.primary} />
          </Icon>

          <Input
            aria-label="FAQ search text"
            ref={inputRef}
            onChange={(event) => setSearchText(event.target.value)}
            data-testid="faqSearchInput"
            placeholder="Search for articles and guides…"
            value={searchText}
            type="search"
          />

          {isLoading && (
            <LoadingBox>
              <ScaleLoader color={theme.backgroundLight} data-testid="inputLoading" height={25} />
            </LoadingBox>
          )}
        </SearchInput>
      </SearchInputContainer>
    </Container>
  );
};

export default FaqSearch;
